import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import { devMode } from "../constants/app";

import { rootReducer } from "./rootSlices";
import { rootSaga } from "./rootSagas";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
   devTools: devMode,
   reducer: rootReducer,
   middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
         serializableCheck: false,
      }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
